import { render, staticRenderFns } from "./doublecheck.vue?vue&type=template&id=6a5b6b36&"
import script from "./doublecheck.vue?vue&type=script&lang=js&"
export * from "./doublecheck.vue?vue&type=script&lang=js&"
import style0 from "./doublecheck.vue?vue&type=style&index=0&id=6a5b6b36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports